import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { getUserMeasurementSystem } from 'modules/meta/selectors';
import { getPlaceCategory } from 'modules/search/selectors';
import { Text } from '@daedalus/atlas/Text';
import { cssTheme } from '@daedalus/atlas/themes';
import { convertMilesToKm, getDistanceFromMessage, messages } from '@daedalus/core/src/utils/distanceFrom';
interface Props {
  distance?: number;
  isSelected: boolean;
}

// @ts-expect-error - styled doesn't see Text has className prop?
const _exp = /*#__PURE__*/() => Text;
const _exp2 = /*#__PURE__*/() => ({
  isSelected
}) => isSelected ? 'white' : cssTheme.colors.content.neutral.c600;
const MessageWrapper = /*#__PURE__*/styled(_exp())({
  name: "MessageWrapper",
  class: "mp2bnrq",
  propsAsIs: true,
  vars: {
    "mp2bnrq-0": [_exp2()]
  }
});

// TODO: mostly copied from DistanceFrom
export const MarkerDistance: FC<Props> = ({
  distance,
  isSelected
}) => {
  const {
    formatMessage
  } = useIntl();
  const userMeasurementSystem = useSelector(getUserMeasurementSystem);
  const placeCategory = useSelector(getPlaceCategory);
  const distanceFromMessage = getDistanceFromMessage({
    placeCategory: placeCategory || 0
  });

  // Show nothing when distance or message not provided
  if (!distance || !distanceFromMessage) return null;
  const convertedDistance = userMeasurementSystem === 'imperial' ? distance : convertMilesToKm(distance);

  // No need to show a rounded 0.0 km
  if (convertedDistance < 0.1) return null;
  const unitMessage = userMeasurementSystem === 'imperial' ? messages.distanceAsMiles : messages.distanceAsKm;

  // TODO: this should be properly localized !!
  const message = `${convertedDistance.toFixed(1)} ${formatMessage(unitMessage)}`;
  return <MessageWrapper variant="labelXS" isSelected={isSelected}>
      {message}
    </MessageWrapper>;
};

require("./MarkerDistance.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MarkerDistance.tsx");